import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { DateUtil } from 'utils/DateUtil';
import rightIcon from 'assets/images/rightb.png';
import leftIcon from 'assets/images/leftb.png';
import 'react-calendar/dist/Calendar.css';
import './styles.scss';

const CalendarContainer = props => {
  const { events_data, dateRangeArray } = props;
  const [date, setDate] = useState(new Date());
  const [dateArray, setDateArray] = useState();
  useEffect(() => {
    generateDatesArray(date);
  }, [date]);

  Date.prototype.addDays = function(days) {
    let dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
  };

  const createNewDate = (first_date, last_date) => {
    let dateArray = [];
    let currentDate = first_date;
    while (currentDate <= last_date) {
      dateArray.push(new Date(currentDate));
      currentDate = currentDate.addDays(1);
    }
    return dateArray;
  };

  const onChange = e => {
    setDate(e);
  };

  const tileDisabled = ({ date, view }) => {
    if (view === 'month') {
      // Check if a date React-Calendar wants to check is on the list of event dates
      if (events_data.find(dDate => DateUtil.getIsSameDay(dDate.date, date))) {
        return 'event-tile';
      }
    }
  };

  const generateDatesArray = selectedDates => {
    let local_date_array = [];
    if (selectedDates.length === undefined) {
      local_date_array = selectedDates;
    } else if (selectedDates.length === 2) {
      local_date_array = createNewDate(selectedDates[0], selectedDates[1]);
    } else local_date_array = selectedDates;
    setDateArray(local_date_array);
    dateRangeArray(local_date_array);
  };

  return (
    <div className={'calender-body'}>
      <Calendar
        onChange={onChange}
        value={date}
        allowPartialRange={true}
        selectRange={onChange}
        // tileDisabled={tileDisabled}
        tileClassName={tileDisabled}
        nextLabel={<img src={rightIcon} />}
        prevLabel={<img src={leftIcon} />}
      />
    </div>
  );
};

export default CalendarContainer;
